import React, { useState, useEffect } from 'react';
import { cn } from '@src/utils/ui';
import { Container } from '@mui/material';
import { FooterLayout } from '../footer';
import { HeaderLayout } from '../header/header';
import PropTypes from 'prop-types';
import { LoggedInUserPropType } from '@src/components/prop-types/user';

const TASK_INSURANCE_FOOTER_PAGES = [
    '/',
    '/merchants/upload',
    '/merchants/dashboard',
    '/merchants/quotation/list',
    '/merchants/order/history',
    '/merchants/items',
    '/pages/provide-a-task',
    '/pages/about'
];

export function Layout({
    children,
    mainContainerProps = {},
    user = null,
    categories = [],
    panels = [],
    showSearchHeader = true,
    showFooter = true,
    banner = null
}) {
    const containerClass = showSearchHeader ? 'tw-mt-[92px] [@media(min-width:813px)]:tw-mt-[122px]' : 'tw-mt-[50px]';
    const [pathname, setPathname] = useState('/');

    useEffect(() => {
        setPathname(window.location.pathname);
    }, []);

    const isMerchant = user?.Roles?.includes('Merchant') || user?.Roles?.includes('Submerchant');
    const showInsuranceDisclaimer =
        TASK_INSURANCE_FOOTER_PAGES.includes(pathname) || (pathname === '/chat/inbox' && isMerchant);
    const isHomepage = pathname === '/';

    return (
        <React.Fragment>
            <div className='header mod' id='header-section'>
                <HeaderLayout categories={categories} user={user} showSearchHeader={showSearchHeader} />
            </div>
            {banner}
            <div
                {...(mainContainerProps?.id ? { id: mainContainerProps.id } : {})}
                className={cn('tw-inline-block tw-w-full', containerClass, mainContainerProps?.className)}
            >
                {children}
            </div>
            {showInsuranceDisclaimer && (
                <Container maxWidth='xl' className='lg:tw-px-[40px] xl:tw-px-[100px]'>
                    <div className='tw-py-6 tw-px-4 tw-text-left tw-text-xs tw-text-gray-600 tw-space-y-3'>
                        <p>
                            *Insurance coverage is subject to the Tasker Insurance policy terms and conditions, including
                            eligibility requirements, limitations, and exclusions. Tasker Insurance is a group insurance
                            policy underwritten by BCAA Insurance Corporation and issued to B.C.A.A. Holdings Ltd. BCAA
                            Insurance Corporation is a subsidiary of B.C.A.A. Holdings Ltd.
                        </p>
                        {isHomepage && (
                            <p>
                                **Offer valid for the first 1000 users who apply the promo code at checkout by May 31, 2026. 
                                $25 discount applies to first use only. One-time use per customer. Promo code must be entered 
                                at time of purchase and cannot be applied retroactively. Offer is non-transferable, not 
                                redeemable for cash, and may not be combined with other promotions or discounts. 
                                Limited-time offer subject to change or cancellation without notice.
                            </p>
                        )}
                        {(isHomepage || pathname === '/pages/provide-a-task' || pathname === '/pages/about') && (
                            <p>
                                BCAA Task Marketplace is a public, peer-to-peer marketplace that connects users with
                                independent service providers. BCAA does not endorse, verify, or warrant the accuracy,
                                quality, suitability, or legality of any service listings, and disclaims all liability
                                arising from or related to such listings. Users are solely responsible for communicating
                                directly with providers to obtain additional information, clarify details, and assess the
                                suitability and legitimacy of any services offered.
                            </p>
                        )}
                    </div>
                </Container>
            )}
            {showFooter && (
                <div className='footer' id='footer-section'>
                    <FooterLayout panels={panels} />
                </div>
            )}
        </React.Fragment>
    );
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    mainContainerProps: PropTypes.shape({
        id: PropTypes.string,
        className: PropTypes.string
    }),
    user: LoggedInUserPropType,
    categories: PropTypes.array,
    panels: PropTypes.array,
    showSearchHeader: PropTypes.bool,
    showFooter: PropTypes.bool,
    banner: PropTypes.node
};
